module.exports = __webpack_public_path__ + "static/media/lunchRed.36015991.png";